import { FC } from "react";
import { PlanetaProps } from "../hooks/usePlanetasRandom";
import Style from "./Style.module.scss";

export type PlanetaComponentProp = {
  image?: PlanetaProps;
  onPress: () => void;
  moveStyle: string;
  displayed: boolean;
  finishTime: boolean;
  position?: React.CSSProperties;
};

const Planeta: FC<PlanetaComponentProp> = ({
  image,
  position,
  moveStyle,
  onPress,
  displayed,
  finishTime
}) => {
  const currentStyle = () => {
    if (finishTime) {
      return Style.NoClicked;
    } else if (!displayed) {
      return Style.removeFigure;
    } else {
      return "";
    }
  };
  return (
    <img
      src={image?.url}
      style={{
        cursor: "pointer",
        ...position
      }}
      onClick={() => {
        onPress();
      }}
      className={`${Style.circulo} ${moveStyle}  ${currentStyle()}`}
      alt='figure'
    />
  );
};

export default Planeta;
